import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { LICENSE_STARTER } from 'model/hams/LicenseType';
import { jiraAddOnKeys, serviceDeskAddOnKeys } from 'data/products/keys';

const NonPubliclyAvailableAddOnMessage = ({ accountDetails }) => {
  const productPackage = accountDetails.merchandise.productPackage || accountDetails.productPackage;
  const { key } = productPackage;
  const { details } = accountDetails.merchandise;

  const isJiraAddOn = jiraAddOnKeys.includes(key);
  const isServiceDeskAddOn = serviceDeskAddOnKeys.includes(key);

  if (isJiraAddOn) {
    return (
      <FormattedMessage
        id="mac.licenses.jira.addon"
        values={{
          hereLink: (
            <a href="https://confluence.atlassian.com/migration/jira-7/server_licensing-faqs">
              <FormattedMessage id="mac.licenses.jira.addon.link" defaultMessage="here" />
            </a>
          ),
        }}
        defaultMessage="We've made some exciting changes to JIRA! Find out what this means for your team {hereLink}"
      />
    );
  }
  if (isServiceDeskAddOn) {
    if (details.licenseType === LICENSE_STARTER) {
      return (
        <FormattedMessage
          id="mac.licenses.jsd.addon.starter"
          values={{
            purchaseNewLicenseLink: (
              <a href={`${config.wacUrl}/purchase/product/jira-servicedesk`}>
                <FormattedMessage
                  id="mac.licenses.jsd.addon.starter.link"
                  defaultMessage="purchase a new license"
                />
              </a>
            ),
          }}
          defaultMessage="To upgrade or renew, {purchaseNewLicenseLink} at the desired tier."
        />
      );
    }
    return (
      <FormattedMessage
        id="mac.licenses.jsd.addon.non-starter"
        values={{
          contactUsLink: (
            <a href={config.companyContact}>
              <FormattedMessage
                id="mac.licenses.jsd.addon.non-starter.link"
                defaultMessage="contact us"
              />
            </a>
          ),
        }}
        defaultMessage="Ready to Renew or Upgrade? Please {contactUsLink}."
      />
    );
  }
  return (
    <FormattedMessage
      id="mac.licenses.non-available.addon"
      defaultMessage="This app cannot be upgraded or renewed through Atlassian. Please contact the vendor directly."
    />
  );
};

export default NonPubliclyAvailableAddOnMessage;
